import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/providers/common';
import { DomSanitizer } from "@angular/platform-browser";
import { Router, ActivatedRoute } from '@angular/router';
import { AddCall } from 'src/providers/addvCall';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { ServicesProvider } from 'src/providers/services';
import { ToastController } from '@ionic/angular';

declare var JitsiMeetExternalAPI: any;

@Component({
  selector: 'app-videocall',
  templateUrl: './videocall.page.html',
  styleUrls: ['./videocall.page.scss'],
})
export class VideocallPage implements OnInit {
  private common = CommonService;
  isShowWelcomePage: boolean = true;
  meetingRoomName: any;
  meetingEndTime: any;
  meetingToken: any;
  meetingRoomId: any;
  api: any;
  constructor(
    private sanitizer: DomSanitizer,
    public addCall: AddCall,
    private androidPermissions: AndroidPermissions,
    private route: ActivatedRoute,
    private services: ServicesProvider,
    public toastController: ToastController,
    public router: Router,) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.meetingRoomName = params['roomName'];
      this.meetingEndTime = params['endTime'];
    });
    const endTimeString = this.meetingEndTime;
    const endTimeArray = endTimeString.split(":").map(Number);
    const endTime = new Date();
    endTime.setHours(endTimeArray[0], endTimeArray[1], endTimeArray[2]);
    const checkEndTimeInterval = setInterval(() => {
      const currentTime = new Date().getTime();
      const endTimestamp = endTime.getTime();
      if (currentTime >= endTimestamp) {
        clearInterval(checkEndTimeInterval);
        // this.api.executeCommand('stopRecording', 'file');
        this.api.executeCommand('hangup');
        this.isShowWelcomePage = true;
        setTimeout(() => {
          this.isShowWelcomePage = false;
          this.onCallEnd();
        }, 2000);
      }
    }, 1000);
  }

  ionViewWillEnter() {
    this.GenerateJWT();
  }

  goBack() {
    this.router.navigate(['/tabs/home']);
  }

  GenerateJWT() {
    let requestdata = JSON.stringify({
      name: localStorage.getItem('patientName'),
      email: localStorage.getItem('Email'),
      avatar: localStorage.getItem('Patient_Profile')
    });
    this.services.postRequest2('GenerateJWT', requestdata).subscribe(
      (res) => {
        this.meetingToken = res.data.token;
        this.meetingRoomId = res.data.roomId;
        if (this.meetingToken != "" && this.meetingRoomId != "" && this.meetingRoomName != "" && this.meetingEndTime != "") {
          this.OpenVC();
        }
      },
      (err) => {
        console.log(err);
      });
  }

  OpenVC() {
    try {
      const domain = '8x8.vc';
      const options = {
        roomName: `${this.meetingRoomId}/TOM VC ${this.meetingRoomName}`,
        parentNode: document.querySelector('#jaas-container'),
        jwt: this.meetingToken,
        configOverwrite: {
          toolbarButtons: ['hangup', 'microphone', 'camera', 'toggle-camera'],
          prejoinPageEnabled: false,
          startWithAudioMuted: false,
          startWithVideoMuted: false,
          disableRecordAudioNotification: true,
          disableJoinLeaveSounds: true,
          disableIncomingMessageSound: true,
          disabledNotifications: [
            'connection.CONNFAIL', // shown when the connection fails,
            'dialog.cameraConstraintFailedError', // shown when the camera failed
            'dialog.cameraNotSendingData', // shown when there's no feed from user's camera
            'dialog.kickTitle', // shown when user has been kicked
            'dialog.liveStreaming', // livestreaming notifications (pending, on, off, limits)
            'dialog.lockTitle', // shown when setting conference password fails
            'dialog.maxUsersLimitReached', // shown when maximmum users limit has been reached
            'dialog.micNotSendingData', // shown when user's mic is not sending any audio
            'dialog.passwordNotSupportedTitle', // shown when setting conference password fails due to password format
            'dialog.recording', // recording notifications (pending, on, off, limits)
            'dialog.remoteControlTitle', // remote control notifications (allowed, denied, start, stop, error)
            'dialog.reservationError',
            'dialog.screenSharingFailedTitle', // shown when the screen sharing failed
            'dialog.serviceUnavailable', // shown when server is not reachable
            'dialog.sessTerminated', // shown when there is a failed conference session
            'dialog.sessionRestarted', // show when a client reload is initiated because of bridge migration
            'dialog.tokenAuthFailed', // show when an invalid jwt is used
            'dialog.tokenAuthFailedWithReasons', // show when an invalid jwt is used with the reason behind the error
            'dialog.transcribing', // transcribing notifications (pending, off)
            'dialOut.statusMessage', // shown when dial out status is updated.
            'liveStreaming.busy', // shown when livestreaming service is busy
            'liveStreaming.failedToStart', // shown when livestreaming fails to start
            'liveStreaming.unavailableTitle', // shown when livestreaming service is not reachable
            'lobby.joinRejectedMessage', // shown when while in a lobby, user's request to join is rejected
            'lobby.notificationTitle', // shown when lobby is toggled and when join requests are allowed / denied
            'notify.audioUnmuteBlockedTitle', // shown when mic unmute blocked
            'notify.chatMessages', // shown when receiving chat messages while the chat window is closed
            'notify.connectedOneMember', // show when a participant joined
            'notify.connectedThreePlusMembers', // show when more than 2 participants joined simultaneously
            'notify.connectedTwoMembers', // show when two participants joined simultaneously
            'notify.dataChannelClosed', // shown when the bridge channel has been disconnected
            'notify.hostAskedUnmute', // shown to participant when host asks them to unmute
            'notify.invitedOneMember', // shown when 1 participant has been invited
            'notify.invitedThreePlusMembers', // shown when 3+ participants have been invited
            'notify.invitedTwoMembers', // shown when 2 participants have been invited
            'notify.kickParticipant', // shown when a participant is kicked
            'notify.leftOneMember', // show when a participant left
            'notify.leftThreePlusMembers', // show when more than 2 participants left simultaneously
            'notify.leftTwoMembers', // show when two participants left simultaneously
            'notify.linkToSalesforce', // shown when joining a meeting with salesforce integration
            'notify.localRecordingStarted', // shown when the local recording has been started
            'notify.localRecordingStopped', // shown when the local recording has been stopped
            'notify.moderationInEffectCSTitle', // shown when user attempts to share content during AV moderation
            'notify.moderationInEffectTitle', // shown when user attempts to unmute audio during AV moderation
            'notify.moderationInEffectVideoTitle', // shown when user attempts to enable video during AV moderation
            'notify.moderator', // shown when user gets moderator privilege
            'notify.mutedRemotelyTitle', // shown when user is muted by a remote party
            'notify.mutedTitle', // shown when user has been muted upon joining,
            'notify.newDeviceAudioTitle', // prompts the user to use a newly detected audio device
            'notify.newDeviceCameraTitle', // prompts the user to use a newly detected camera
            'notify.noiseSuppressionFailedTitle', // shown when failed to start noise suppression
            'notify.participantWantsToJoin', // shown when lobby is enabled and participant requests to join meeting
            'notify.participantsWantToJoin', // shown when lobby is enabled and participants request to join meeting
            'notify.passwordRemovedRemotely', // shown when a password has been removed remotely
            'notify.passwordSetRemotely', // shown when a password has been set remotely
            'notify.raisedHand', // shown when a partcipant used raise hand,
            'notify.screenShareNoAudio', // shown when the audio could not be shared for the selected screen
            'notify.screenSharingAudioOnlyTitle', // shown when the best performance has been affected by screen sharing
            'notify.selfViewTitle', // show "You can always un-hide the self-view from settings"
            'notify.startSilentTitle', // shown when user joined with no audio
            'notify.suboptimalExperienceTitle', // show the browser warning
            'notify.unmute', // shown to moderator when user raises hand during AV moderation
            'notify.videoMutedRemotelyTitle', // shown when user's video is muted by a remote party,
            'notify.videoUnmuteBlockedTitle', // shown when camera unmute and desktop sharing are blocked
            'prejoin.errorDialOut',
            'prejoin.errorDialOutDisconnected',
            'prejoin.errorDialOutFailed',
            'prejoin.errorDialOutStatus',
            'prejoin.errorStatusCode',
            'prejoin.errorValidation',
            'recording.busy', // shown when recording service is busy
            'recording.failedToStart', // shown when recording fails to start
            'recording.unavailableTitle', // shown when recording service is not reachable
            'toolbar.noAudioSignalTitle', // shown when a broken mic is detected
            'toolbar.noisyAudioInputTitle', // shown when noise is detected for the current microphone
            'toolbar.talkWhileMutedPopup', // shown when user tries to speak while muted
            'transcribing.failedToStart', // shown when transcribing fails to start
            'recording.on', // OR Use --> 'recording.linkGenerated',
          ],
          buttonsWithNotifyClick: ['hangup', 'microphone', 'camera', 'toggle-camera'],
          conferenceInfo: {
            autoHide: ['subject', 'conference-timer']
          },
        },
      };
      this.api = new JitsiMeetExternalAPI(domain, options);
  
      // api.addEventListener('notificationTriggered', (e: any) => {});
  
      this.api.addEventListener('toolbarButtonClicked', (e: any) => {
        if (e.key == "hangup" && e.preventExecution == true) {
          this.api.executeCommand('stopRecording', 'file');
          this.api.executeCommand('hangup');
          this.isShowWelcomePage = true;
          setTimeout(() => {
            this.isShowWelcomePage = false;
            this.onCallEnd();
          }, 2000);
        } else if (e.key == "microphone" && e.preventExecution == true) {
          this.api.executeCommand('toggleAudio');
        } else if (e.key == "camera" && e.preventExecution == true) {
          this.api.executeCommand('toggleVideo');
        } else if (e.key == "toggle-camera" && e.preventExecution == true) {
          this.api.executeCommand('toggleCamera', 'facingMode');
        } else if (e.key == "desktop" && e.preventExecution == true) {
          this.api.executeCommand('toggleShareScreen');
        }
      });
  
      this.api.addEventListener('videoConferenceJoined', () => {
        this.isShowWelcomePage = false;
        // this.api.startRecording({ mode: "file" });
      });
  
      // this.api.addEventListener('videoConferenceLeft', () => {
      //   this.api.executeCommand('stopRecording', 'file');
      // });
  
      // this.api.addEventListener('readyToClose', () => {
      //   this.onCallEnd();
      // });
      
    } catch (error) {
      this.presentToast('Please try again.');
      setTimeout(() => {
        this.isShowWelcomePage = false;
        this.onCallEnd();
      }, 2000);
    }
  }

  async presentToast(msg) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 2000,
      cssClass: 'toastStyle',
    });
    toast.present();
  }

  onCallEnd() {
    localStorage.removeItem("jitsiLocalStorage");
    this.router.navigate(['/tabs/appointments']);
  }
  
}
